<template>
  <div>
    <VerifyIdentityError
      v-if="availableMfaModalities.length === 0"
      class="md:w-480 md:mx-auto"
      :cancelText="$t('common.back_btn')"
      :errorTitle="$t('common.no_contact_info_found')"
      :errorBody="$t('common.contact_health_plan_csr.help', [coalescedSupportNumber])"
      @cancel="onCancel"
    />
    <ModalitySelect
      v-else
      :errorText="errorText"
      :helperText="$t('common.contact_health_plan_csr.contact_info_change', [coalescedSupportNumber])"
      :mfaPreference="mfaType"
      :availableMfaModalities="availableMfaModalities"
      @continue="onMfaSelect"
      @cancel="onCancel"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RegistrationLayoutTitles from '@components/layouts/RegistrationLayoutTitles'
import { Form, FormRadioSelect } from '@components/common/forms'
import { ModalitySelect, VerifyIdentityError } from '@components/common/mfa'
import supportMixin from '@components/mixins/support'

export default {
  components: {
    Form,
    FormRadioSelect,
    ModalitySelect,
    RegistrationLayoutTitles,
    VerifyIdentityError,
  },
  mixins: [supportMixin],
  data() {
    return {
      errorText: null,
    }
  },
  computed: {
    ...mapGetters('member', ['availableMfaModalities', 'mfaType']),
  },
  methods: {
    ...mapActions('member', ['updateMfaPreference']),
    onCancel() {
      this.$emit('cancel')
    },
    onMfaSelect(mfaPreference) {
      this.updateMfaPreference(mfaPreference)
        .then(() => {
          this.$emit('continue')
        })
        .catch((error) => {
          this.errorText = error.json.message
        })
    },
  },
}
</script>
